<template>
  <portal to="popup">
    <transition name="spinner">
      <div class="container" v-if="show">
        <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
        <div class="message">{{ message || $t('message.loading') }}</div>
      </div>
    </transition>
  </portal>
</template>

<script>
export default {
  name: 'Spinner',
  props: ['message', 'show'],
}
</script>

<style scoped>
.container {
  position: fixed;
  z-index: 5000;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0,0,0,0.85);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #fff;
}
.message {
  margin-top: 12px;
  font-weight: bold;
  font-size: 14px;
}
.spinner-enter-active, .spinner-leave-active {
  transition: opacity 200ms ease;
}
.spinner-enter, .spinner-leave-to {
  opacity: 0;
}
</style>

<style scoped>
.lds-ring {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 64px;
  height: 64px;
  margin: 8px;
  border: 8px solid #fff;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #fff transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
